const WTW_NOVA_HOSTNAMES = new Set(['nova.wtwco.com', 'stage-nova.wtwco.com']);

export function isWtwNovaHostname(hostname?: string | null): boolean {
  return hostname != null && WTW_NOVA_HOSTNAMES.has(hostname.trim().toLowerCase().replace(/:\d+$/, ''));
}
